import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ToHttpHeadersService } from '../utils';
import { map, Observable } from 'rxjs';
import { PaginatedResponse } from '@shared/models';

@Injectable({
  providedIn: 'root'
})
export class PayrollService {

  readonly payrollUrl = `/api/v1/payroll`;
  readonly recordsUrl = `/api/v1/records`;
  readonly http = inject(HttpClient);
  readonly toHttpHeaders = inject(ToHttpHeadersService);

  getEmployeeStatuses(): Observable<any> {
    return this.http.get<any>(`${this.recordsUrl}/employee/statuses`)
      .pipe(map(d => ({ results: d })))
  }

  list(): Observable<PaginatedResponse<any>> {
    return this.http.get<PaginatedResponse<any>>(`${this.payrollUrl}/payroll-process?sort=id,DESC`, {});
  }

  getPayslip(id: number) {
    return this.http.get<any>(`${this.payrollUrl}/payroll-process/payroll-slip/${id}`);
  }

  getPayslipSalaryComp(id: number) {
    return this.http.get<any>(`${this.payrollUrl}/payroll-process/payroll-slip/${id}/salary-computation`);
  }

  getPayslipOthers(id: number) {
    return this.http.get<any>(`${this.payrollUrl}/payroll-process/payroll-slip/${id}/others`);
  }

  getWorkHoursByPayrollSlipId(id: number): Observable<any> {
    return this.http.get<any>(`${this.payrollUrl}/payroll-process/payroll-slip/${id}/work-hours`);
  }
  // post(module: string, data: any): Observable<any> {
  // 	return this.http.post<any>(`${this.url}/${module}`, data, this.toHttpHeaders.generateHeaders(ListActions.CREATE, this.label[module]));
  // }

  // put(module: string, data: any): Observable<any> {
  // 	return this.http.put<any>(`${this.url}/${module}`, data, this.toHttpHeaders.generateHeaders(ListActions.UPDATE, this.label[module]));
  // }

  // delete(module: string, id: number): Observable<any> {
  // 	return this.http.delete<any>(`${this.url}/${module}/${id}`, this.toHttpHeaders.generateHeaders(ListActions.DELETE, this.label[module]));
  // }

  // view(module: string, id: number): Observable<any> {
  // 	return this.http.get<any>(`${this.url}/${module}/${id}`);
  // }
}
